const artistsEN = {
    "view": {
        "table": {
            "title": "Your artists list",
            "column": {
                "name": "Artist Name",
                "owner": "Owner",
                "spotify_link": "Spotify Link",
                "apple_music_link": "Apple Music Link",
                "amazon_music_link": "Amazon Music Link",
                "deezer_link": "Deezer Link",
                "flagged": "Flagged",
                "blacklisted": "Blacklisted",
                "action": "Action"
            },
            "button": {
                "export_csv": "Export CSV"                    
            },
            "placeholder": {
                "search": "Search..."
            },
            "message": {
                "artistFlagged": "This artist is flagged and escrow payment is required to distribute the release to Spotify.",
                "artistNotFlagged": "This artist is eligible for Spotify distribution.",
                "artistBlacklisted": "This artist is blacklisted and not eligible for distribution.",
                "artistNotBlacklisted": "This artist is not blacklisted and eligible for distribution.",
            }
        },
        "message": {
            "success": "Artist has been removed!",
            "error": "Something went wrong! Please refresh page and try again!",
            "notSubscribed": "You are not subscribed to any plan, therefore you can only add <strong>3 Artists</strong>, Please <3>subscribe</3> to a plan to avail unlimited amount of Artists.",
            "subscriptionUpgrade": "Your current subscription plan does not support this feature. Please <1>upgrade</1> your subscription plan to avail this feature.",
            "subscriptionExpired": "Your subscription has expired. Please <1>resume</1> your subscription to avail this feature.",
            "noAccess": "You don't have access to this module, please contact the support team for further information."
        },
        "modal": {
            "cantBeDeleted": {
                "header": "Artist {{artistName}} can't be deleted",
                "body": "Artist {{artistName}} can't be deleted as they already have Track(s)/Release(s) associated with them."
            },
            "delete": {
                "header": "Delete {{artistName}}?",
                "body": "Are you sure that you really want to delete this artist? This action could detach your artist from the assigned release."
            },
            "edit": {
                "header": "Edit {{artistName}}?",
                "body": "Are you sure that you want to change your artist name? This could have an effect on release metadata."
            }
        },
    },
    "add": {
        "title": "Add Artist",
        "form": {
            "label": {
                "is_new_artist": "Is New Artist",
                "spotify_profile": "Spotify Profile",
                "deezer_profile": "Deezer Profile",
                "amazon_music_profile": "Amazon Music Profile",
                "spotify_image": "Spotify Image",
                "deezer_image": "Deezer Image",
                "amazon_music_image": "Amazon Music Image",
                "spotify_id": "Spotify ID",
                "deezer_id": "Deezer ID",
                "amazon_music_id": "Amazon Music ID",
                "apple_id": "Apple ID",
                "name": "Name",
                "name_preference": "Name Preference",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Email",
                "subuser": "Sub-User"
            },
            "help_text": {
                "is_new_artist": "Are you adding a new artist i.e. If your artist has releases on Spotify/Deezer/Amazon Music/Apple Music then select No otherwise select Yes.",
                "spotify_profile": "Note: Only use this dropdown if you want to add an Artist who is already on Spotify otherwise click on Not Found button.",
                "deezer_profile": "Note: Only use this dropdown if you want to add an Artist who is already on Deezer otherwise click on Not Found button.",
                "amazon_music_profile": "Note: Only use this dropdown if you want to add an Artist who is already on Amazon Music otherwise click on Not Found button.",
                "apple_id": "Note: Only use this field if you want to add an Artist who is already on Apple Music otherwise click on Not Found button.",
                "subuser": "Note: Only use this dropdown if you want to Add Artist for any of your Sub-users otherwise leave un-selected."
            },
            "placeholder": {
                "subuser": "Select Sub-user...",
                "spotify_profile": "Enter Artist Name i.e. The Weekend or Artist's Spotify ID i.e. 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Enter Artist Name i.e. The Weekend or Artist's Deezer ID i.e. 1406580",
                "amazon_music_profile": "Enter Artist Name i.e. The Weekend or Artist's Amazon ASIN i.e. B005GI0T2U",
                "apple_id": "Please enter a valid Apple ID. Example: 635806095"
            },
            "button": {
                "reset": "Reset",
                "not_found": "Not Found",
                "submit": "Submit"
            },
            "option": {
                "yes": "Yes",
                "no": "No"
            },
            "validation": {
                "name_required": "Name is required",
                "name_invalid": "Artist name must contain 'DJ' in uppercase only",
                "email_required": "Email is required",
                "email_invalid": "Please enter a valid email",
                "name_duplicate": "Artist already exists",
                "name_mismatch": "Artist name must match for all stores",
                "spotify_id_invalid": "Please add a valid Spotify ID. Example: 6eUKZXaKkcviH0Ku9w2n3B. Check our Help Center for more info.",
                "apple_id_required": "Apple ID is required",
                "apple_id_invalid": "Please add a valid Apple ID. Example: 635806095. Check our Help Center for more info."
            }
        },
        "modal": {
            "title": {
                "new_artist_declaration": "New Artist Declaration",
                "profile_not_present_declaration": "Profile Not Present Declaration"
            },
            "body": {
                "profile_not_present_declaration": "I confirm that this Artist's profile is not present on <strong>{{store}}</strong> and that the profile of this Artist be created freshly on <strong>{{store}}</strong>.",
                "new_artist_declaration": "I confirm that this Artist's profile is not present on any of the following stores and that the profile of this Artist be created freshly on these stores.",
                "new_artist_declaration_amazon_music": "Amazon Music",
                "new_artist_declaration_apple_music": "Apple Music",
                "new_artist_declaration_deezer": "Deezer",
                "new_artist_declaration_spotify": "Spotify"
            },
            "button": {
                "confirm": "Confirm",
                "cancel": "Cancel"
            }
        },
        "message": {
            "success": "Artist has been added!",
            "error": "Something went wrong! Please refresh page and try again!",
            "errorBlacklisted": "One or more of the details that you have provided are related to an artist that is blacklisted. If you are sure that the artist is not blacklisted, please contact the support team for further information."
        }
    },
    "update": {
        "title": "Edit Artist",
        "form": {
            "label": {
                "spotify_profile": "Spotify Profile",
                "deezer_profile": "Deezer Profile",
                "amazon_music_profile": "Amazon Music Profile",
                "spotify_image": "Spotify Image",
                "deezer_image": "Deezer Image",
                "amazon_music_image": "Amazon Music Image",
                "spotify_id": "Spotify ID",
                "deezer_id": "Deezer ID",
                "amazon_music_id": "Amazon Music ID",
                "apple_id": "Apple ID",
                "name": "Name",
                "name_preference": "Name Preference",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "amazon_music": "Amazon Music",
                "email": "Email",
                "flagged": "Flagged",
            },
            "help_text": {
                "spotify_profile": "Note: Only use this dropdown if you want to add an Artist who is already on Spotify otherwise click on Not Found button.",
                "deezer_profile": "Note: Only use this dropdown if you want to add an Artist who is already on Deezer otherwise click on Not Found button.",
                "amazon_music_profile": "Note: Only use this dropdown if you want to add an Artist who is already on Amazon Music otherwise click on Not Found button.",
                "apple_id": "Note: Only use this field if you want to add an Artist who is already on Apple Music otherwise click on Not Found button."
            },
            "placeholder": {
                "spotify_profile": "Enter Artist Name i.e. The Weekend or Artist's Spotify ID i.e. 144HzhpLjcR9k37w5Ico9B",
                "deezer_profile": "Enter Artist Name i.e. The Weekend or Artist's Deezer ID i.e. 1406580",
                "amazon_music_profile": "Enter Artist Name i.e. The Weekend or Artist's Amazon ASIN i.e. B005GI0T2U",
                "apple_id": "Please enter a valid Apple ID. Example: 635806095"
            },
            "button": {
                "reset": "Reset",
                "not_found": "Not Found",
                "submit": "Submit"
            },
            "validation": {
                "name_required": "Name is required",
                "email_required": "Email is required",
                "email_invalid": "Please enter a valid email",
                "name_duplicate": "Artist already exists",
                "name_mismatch": "Artist name must match for all stores",
                "name_mismatch_spotify": "Spotify Profile Name must match with the Artist Name",
                "name_mismatch_deezer": "Deezer Profile Name must match with the Artist Name",
                "name_mismatch_amazon_music": "Amazon Profile Name must match with the Artist Name",
                "spotify_id_invalid": "Please add a valid Spotify ID. Example: 6eUKZXaKkcviH0Ku9w2n3B. Check our Help Center for more info.",
                "apple_id_required": "Apple ID is required",
                "apple_id_invalid": "Please add a valid Apple ID. Example: 635806095. Check our Help Center for more info."
            }
        },
        "modal": {
            "title": {
                "profile_reset_declaration": "Profile Reset Declaration",
                "profile_not_present_declaration": "Profile Not Present Declaration"
            },
            "body": {
                "profile_not_present_declaration": "I confirm that this Artist's profile is not present on <strong>{{store}}</strong> and that the profile of this Artist be created freshly on <strong>{{store}}</strong>.",
                "profile_reset_declaration": "I am aware that by resetting this Artist's <strong>{{store}}</strong> profile will remove the <strong>{{store}} ID</strong> from everywhere in the system and by doing so, it is likely to cause disruptions in the stores and artists to mismatch."
            },
            "button": {
                "confirm": "Confirm",
                "cancel": "Cancel"
            }
        },
        "message": {
            "success": "Artist of name '{{artistName}}' has been updated!",
            "error": "Something went wrong! Please refresh page and try again!",
            "errorBlacklisted": "One or more of the details that you have provided are related to an artist that is blacklisted. If you are sure that the artist is not blacklisted, please contact the support team for further information."
        }
    },
    "add_from_wishlist": {
        "title": "Add Artist",
        "form": {
          "label": {
            "spotify_profile": "Spotify Profile",
            "deezer_profile": "Deezer Profile",
            "amazon_music_profile": "Amazon Music Profile",
            "spotify_id": "Spotify ID",
            "spotify_image": "Spotify Image",
            "deezer_id": "Deezer ID",
            "deezer_image": "Deezer Image",
            "amazon_music_id": "Amazon ID",
            "amazon_music_image": "Amazon Music Image",
            "apple_id": "Apple ID",
            "apple_image": "Apple Image",
            "name": "Name",
            "name_preference": "Name Preference",
            "spotify": "Spotify",
            "deezer": "Deezer",
            "amazon_music": "Amazon Music",
            "email": "Email",
            "subuser": "Sub-User"
          },
          "placeholder": {
            "spotify_profile": "Enter Artist Name i.e. The Weekend or Artist's Spotify ID i.e. 144HzhpLjcR9k37w5Ico9B",
            "deezer_profile": "Enter Artist Name i.e. The Weekend or Artist's Deezer ID i.e. 1406580",
            "amazon_music_profile": "Enter Artist Name i.e. The Weekend or Artist's Amazon ASIN i.e. B005GI0T2U",
            "apple_id": "Please enter a valid Apple ID. Example: 635806095",
            "subuser": "Select Sub-user..."
          },
          "help_text": {
            "spotify_profile": "Note: Only use this dropdown if you want to add an Artist who is already on Spotify otherwise click on Not Found button.",
            "deezer_profile": "Note: Only use this dropdown if you want to add an Artist who is already on Deezer otherwise click on Not Found button.",
            "amazon_music_profile": "Note: Only use this dropdown if you want to add an Artist who is already on Amazon Music otherwise click on Not Found button.",
            "apple_id": "Note: Only use this field if you want to add an Artist who is already on Apple Music otherwise click on Not Found button.",
            "subuser": "Note: Only use this dropdown if you want to Add Artist for any of your Sub-users otherwise leave un-selected."
          },
          "button": {
            "reset": "Reset",
            "notFound": "Not Found?",
            "submit": "Submit",
            "cancel": "Cancel",
            "confirm": "Confirm"
          },
          "validation": {
            "name_required": "Name is required",
            "email_required": "Email is required",
            "email_invalid": "Please enter a valid email",
            "spotify_id_invalid": "Please add a valid Spotify ID. Example: 6eUKZXaKkcviH0Ku9w2n3B. Check our Help Center for more info.",
            "apple_id_required": "Apple ID is required",
            "apple_id_invalid": "Please add a valid Apple ID. Example: 635806095. Check our Help Center for more info."
          },
          "message": {
            "errorArtistExists": "Artist already exists",
            "errorNameMismatch": "Artist name must match for all stores",
            "errorSpotifyNameMismatch": "Spotify Profile Name must match with the Artist Name",
            "errorDeezerNameMismatch": "Deezer Profile Name must match with the Artist Name",
            "errorAmazonNameMismatch": "Amazon Profile Name must match with the Artist Name",
          },
        },
        "message": {
            "success": "Artist has been added!",
            "error": "Something went wrong! Please refresh page and try again!",
            "errorBlacklisted": "One or more of the details that you have provided are related to an artist that is blacklisted. If you are sure that the artist is not blacklisted, please contact the support team for further information."
          },
          "modal": {
            "profileMissing": {
              "header": "Profile Not Present Declaration",
              "body": "I confirm that this Artist's profile is not present on <strong>{{storeName}}</strong> and that the profile of this Artist be created freshly on <strong>{{storeName}}</strong>.",
              "button": {
                "cancel": "Cancel",
                "confirm": "Confirm"
              }
            }
          },
    },
    "viewDetails": {
        "view": {
            "label": {
                "followers": "FOLLOWERS",
                "popularity": "POPULARITY",
                "genres": "GENRES",
                "flagged": "FLAGGED",
                "notAvailable": "Not Available",
                "notAvailableAbbr": "N/A",
            },
            "similarArtists": {
                "title": "Similar Artists",
                "table": {
                    "column": {
                        "artist": "Artist",
                        "followers": "Followers",
                        "popularity_pct": "Popularity (%)",
                        "genres": "Genres",
                        "wishlist": "Wishlist",
                    }
                },
                "label": {
                    "notAvailable": "Not Available",
                    "notAvailableAbbr": "N/A",
                },
                "message": {
                    "error": "Something went wrong! Please refresh page and try again!"
                },
                "modal": {
                    "addToWishlist": {
                        "header": "Add Artist {{artistName}} To Wishlist",
                        "body": "Are you sure that you want to add artist {{artistName}} to your wishlist?",
                        "message": {
                            "success": "Artist added to wishlist!",
                        },
                    },
                    "removeFromWishlist": {
                        "header": "Remove Artist {{artistName}} From Wishlist",
                        "body": "Are you sure that you want to remove artist {{artistName}} from your wishlist?",
                    }
                }
            },
            "topTracks": {
                "title": "Top Tracks",
                "table": {
                    "column": {
                        "track": "Track",
                        "release": "Release",
                        "artists": "Artist(s)",
                        "popularity_pct": "Popularity (%)",
                        "preview": "Preview"
                    }
                },
                "label": {
                    "audioElementNotSupported": "Your browser does not support the audio element."
                }
            },
        }
    },
};

export default artistsEN;